var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignBulk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.083,
    height: 17.667,
    viewBox: "0 0 22.083 17.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(-1.125 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M16.708,13.333a4.417,4.417,0,1,0-4.417-4.417A4.43,4.43,0,0,0,16.708,13.333Zm0,2.208c-2.926,0-8.833,1.491-8.833,4.417v2.208H25.542V19.958C25.542,17.032,19.634,15.542,16.708,15.542Z",
    transform: "translate(-2.333)",
    fill: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M5.542,14.194V11.25H4.069v2.944H1.125v1.472H4.069v2.944H5.542V15.667H8.486V14.194Z",
    transform: "translate(0 -2.333)",
    fill: "#a3a3a3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignBulk);
export default __webpack_public_path__ + "static/media/assign-bulk.7ad05a7557ed6dd4b1dd189409ce65ea.svg";
export { ForwardRef as ReactComponent };